export { default } from './product-diagram-title';
